import { AssignmentsLink } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/AssignmentsLink/AssignmentsLink";

export { AssignmentsLink };
